import React from 'react'

import { ButtonNew, IconNew } from '..'
import { LocationContext, SiteDataContext } from '../../components/page-wrapper'
import RichText from '../../components/rich-text'
import Image from 'next/image'
import { getMicroCopy } from '../../utils/microcopy'
import { getUrl } from '../../utils/urls'
import { useMicroCopyData } from '@/src/context/MicroCopyContext'
import { BUTTON_VARIANT } from '../ButtonNew/ButtonNew'
import { useNavigationData } from '@/src/context/NavigationContext'

const FeatureContact = ({
  image,
  icon,
  title,
  description,
  action,
  extraInfo = [],
  price,
  month,
  bulletListColor
}) => {
  const { navigationItems } = useNavigationData()
  const microCopyData = useMicroCopyData()
  const { lang, isTextRtl } = React.useContext(SiteDataContext)
  const location = React.useContext(LocationContext)
  const { slugPrefix } = location

  const getExtraInfoKey = () => {
    if (!Array.isArray(extraInfo)) return

    const itemKey = extraInfo.find((eInfo) => eInfo['__typename'] === 'Microcopy')?.key || ''

    if (!itemKey) return null //TODO remove array necessity
    return `${itemKey}`
  }

  return (
    <div
      dir={isTextRtl ? 'rtl' : 'ltr'}
      className={
        'c-feature-contact l-grid l-grid__col:12/12 l-grid__col:6/12@at:viewport-7 l-grid__col:4/12@at:viewport-9'
      }
    >
      {image ? (
        <div style={{ position: 'relative', height: '17.5rem' }}>
          <Image src={image.url} alt={image.title} fill style={{ objectFit: 'cover' }} />
        </div>
      ) : null}
      <div className={'c-feature-contact__card'}>
        <div className={'c-feature-contact__header'}>
          <div className={'c-feature-contact__title'}>
            {icon ? (
              <IconNew
                name={icon}
                classes={`c-feature-card-list__items-icon c-feature-card-list__items-icon--${bulletListColor}`}
              />
            ) : null}
            {title ? <h4>{title}</h4> : null}
          </div>
          {Array.isArray(extraInfo) && extraInfo.length > 0 ? (
            <div className="c-feature-contact__extraInfo">
              {typeof extraInfo === 'object'
                ? getMicroCopy({
                    key: getExtraInfoKey(),
                    data: microCopyData[lang],
                    tokens: { period: month, price: price }
                  })
                : extraInfo}
            </div>
          ) : null}
        </div>
        {description ? <RichText data={description} tokens={{}} /> : null}
        {action ? (
          <ButtonNew
            variant={BUTTON_VARIANT.TERTIARY}
            url={getUrl({
              navItem: action,
              slugPrefix: slugPrefix,
              navigationItems: navigationItems
            })}
            size={'md'}
          >
            {action.title} <IconNew name={'ti-arrow-narrow-right'} />
          </ButtonNew>
        ) : null}
      </div>
    </div>
  )
}

export default FeatureContact
